import Image from 'next/image';
import classNames from "classnames"
import CheckboxGroup from "@/migrated-widgets/table-map/components/molecules/CheckboxGroup";
import { locationProducts } from "@/migrated-widgets/table-map/components/organisms/TableMap/constants";
import { CheckboxGroupItem } from "@/migrated-widgets/table-map/components/molecules/CheckboxGroup/Item";
import { CheckboxIcon } from "@/migrated-widgets/table-map/components/icons/CheckboxIcon";

interface FilterByProductProps {
  products: string[];
  setProducts: React.Dispatch<React.SetStateAction<string[]>>;
  distinctProducts: string[];
}

export const FilterByProduct: React.FC<FilterByProductProps> = ({ products, setProducts, distinctProducts }) => {
  const toggleProduct = (product: string) => {
    setProducts((prev) => {
      if (prev.includes(product)) return products.filter(el => el !== product)
      return [...prev, product]
    })
  }

  const isActiveProduct = (product?: string) => {
    if (!product) return false;
    if (!products.length) return true;
    return !products.includes(product);
  }

  return (
    <CheckboxGroup checkboxes={{ className: "gap-6", width: "w-full" }}>
      {locationProducts.map((productData) => {
        const product = distinctProducts.find(location => location === productData.value);
        return (
          <CheckboxGroupItem
            key={productData.value}
            onClick={() => product ? toggleProduct(product) : null}
            className={classNames("text-sm text-left text-brand-black", { "text-gray-400": !product })}
            onHoverClass=""
            cursor={product ? "cursor-pointer" : "cursor-not-allowed"}
          >
            <div className="flex items-center gap-1">
              <div className={classNames(
                "w-4 h-4 rounded-[3px]",
                { "bg-gray-100 border border-table-map-lightGray": product },
                { "bg-gray-50 border border-gray-300": !product },
                { "!bg-[#35434a] border-0": isActiveProduct(product) }
              )}>
                {isActiveProduct(product) && <CheckboxIcon />}
              </div>
              {productData.icon &&
                <Image src={productData.icon} alt={productData.name} width={22} height={22} className={classNames({ "grayscale": !product })} unoptimized />
              }
              <span>{productData.name}</span>
            </div>
          </CheckboxGroupItem>
        );
      })}
    </CheckboxGroup>
  )
}
